export default {
    panelLoading: false,
    panelsListLoading: false,
    panelsList: [],
}